import { ArrayNotEmpty, IsArray, IsInt, IsNotEmpty } from 'class-validator';

export class OrderDialogMenuDto {
  @IsInt()
  @IsNotEmpty()
  name: string

  @IsArray()
  @ArrayNotEmpty()
  products: MenuItem[];
}

export class MenuItem {
  id: number;
  name: string;
  price: string;
  description?: string;
  tag?: string;
  menuCategory: string;
  productCategories: string[];
  modifiers: ModifierItem[];
}

export class ModifierItem {
  id: number;
  name: string;
  description?: string;
  price: string
}